import React from 'react';

const ProjectsContext = React.createContext();

export { ProjectsContext as default };